export default "__VITE_ASSET__DZumkFwW__"